import React from 'react';
import { handleCheckoutClick, CHECKOUT_URL } from '../lib/pixel';
export function Nav() {
  return <nav className="sticky top-10 z-40 bg-white shadow-sm" data-id="element-139">
      <div className="container mx-auto px-6 lg:px-12 py-4 flex items-center justify-between" data-id="element-140">
        <h1 className="text-xl lg:text-2xl font-bold text-[#2D5A34]" data-id="element-141">
          Código Hormonal 40+
        </h1>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="bg-[#C2856A] text-white px-4 py-2 rounded-full text-sm font-semibold hover:bg-[#B37659] transition-colors" data-id="element-142">
          COMPRAR AHORA — $8.49
        </a>
      </div>
    </nav>;
}